import React, { useState, useContext, useEffect } from "react";
import { Field } from "formik";
import {
  FieldInputDollar,
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldTextarea,
  FieldInputNumber,
  FieldInputPercentage,
  DatePicker,
  MultiSelectDropdown,
  FieldMultiSelectButtonGroup,
  LoaderWrapper,
  AddToolTip,
  GetInitials,
  SliderPanel,
} from "../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  toMultiSelectValueById,
} from "../../../../utils";
import { useRequest, useRouterParams } from "../../../../abstracts";
import {
  listTrustee,
  listCustodian,
  GetInvestmentTradingPartnerList,
  GetPlanTradingPartnerList,
  UpsertInvestmentWithClearingPartner,
} from "../../../../services";
import { createPlanStore } from "../../../../contexts";
import { isEmpty, get, isNull } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { Button, Form } from "react-bootstrap";
const TrusteeCustodianDetails = (props) => {
  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    planId,
    handleChange,
    setToggle,
    setTabGrey,
  } = props;

  const { state } = useContext(createPlanStore);
  const { flow, planid, investmentId } = useRouterParams();
  const [isEditClearingPartner, setIsEditClearingPartner] = useState(false);
  const [planClearingPartnerDetails, setPlanClearingPartnerDetails] = useState(
    []
  );
  const [clearingPartnerAccount, setClearingPartnerAccount] = useState({});
  const [investmentPartner, setinvestmentPartner] = useState(0);
  const { response: trusteeList } = useRequest({
    method: listTrustee,
    payload: planId,
    defaultResponse: [],
  });
  const { response: custodianList, loading: load } = useRequest({
    method: listCustodian,
    payload: planId,
    defaultResponse: [],
  });

  // console.log(investmentId,planid,flow, "clearingPartnerAccount");
  useEffect(() => {
    if (isEditClearingPartner) {
      GetPlanTradingPartnerList(planId)
        .then((res) => {
          setPlanClearingPartnerDetails(
            get(res, "planAssociatedClearingPartnerAccounts", [])
          );
        })
        .catch((err) => {});
    }
    GetInvestmentTradingPartnerList(parseInt(investmentId))
      .then((res) => {
        if (res.isSuccessful) {
          setClearingPartnerAccount(
            get(res, "investmenrAssociatedClearingPartnerAccount", {})
          );
        }
      })
      .catch((err) => {});
  }, [isEditClearingPartner]);
  const trusteeData = get(trusteeList, "trustees", []);
  const custodianData = get(custodianList, "custodians", []);

  const clearanceTime = get(values, fields.clearanceTime, []);
  const onAddClick = () => {
    setIsEditClearingPartner(!isEditClearingPartner);
  };
  const onSave = () => {
    UpsertInvestmentWithClearingPartner({
      investmentId: parseInt(investmentId),
      clearingPartnerAccountMappingId: parseInt(investmentPartner),
    })
      .then((res) => {
        setIsEditClearingPartner(!isEditClearingPartner);
      })
      .catch((err) => {});
  };
  console.log(investmentPartner, "investmentPartner");
  return (
    <LoaderWrapper isLoading={false}>
      {!isEmpty(clearingPartnerAccount) && (
        <div className="clearing-partner-added-cards">
          <div className="left-component-clearing-partner">
            <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
              {!isEmpty(clearingPartnerAccount?.logo) ? (
                <img
                  alt=""
                  src={clearingPartnerAccount?.logo}
                  style={{ width: "90px", height: "74px" }}
                  className="img-fluid"
                />
              ) : (
                <GetInitials name={clearingPartnerAccount?.name} />
              )}
            </div>

            <div className="clearing-partner-description-box">
              <AddToolTip
                name={clearingPartnerAccount?.name}
                className="ft-14 font-weight-500 pb-3 clearing-partner-name"
              />
              <div className="clearing-partner-associated-plans">
                {clearingPartnerAccount?.totalPlans} Associated Plans
              </div>
            </div>
          </div>
          <div className="right-component-investment-clearing-partner">
            <div className="inner-bank-details">
              <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                Clearing Partner Account Details
              </div>
              <AddToolTip
                name={clearingPartnerAccount?.clearingPartnerId}
                className="ft-14 font-weight-500 pb-3 clearing-partner-name"
              />
              <div className="clearing-partner-associated-plans">
                {clearingPartnerAccount?.description}
              </div>
            </div>
            <FontAwesomeIcon
              icon={faEdit}
              className="edit-icon"
              size="2x"
              onClick={onAddClick}
            />
          </div>
        </div>
      )}
      <SliderPanel
        isOpen={isEditClearingPartner}
        size="50"
        onClose={onAddClick}
        showCancel={false}
      >
        <div className="clearing-partner-inside-content">
          <div className="d-flex justify-content-between align-baseline">
            <div>
              <p className="investment-heading">Edit Clearing Partner</p>
            </div>
            <div>
              <Button variant="secondary" onClick={onAddClick}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onSave} className="ml-4">
                Save
              </Button>
            </div>
          </div>
          {!isEmpty(planClearingPartnerDetails) &&
            planClearingPartnerDetails.map((e, i) => {
              return (
                <div className="clearing-partner-added-cards">
                  <div className="left-component-clearing-partner">
                    <Form.Check // prettier-ignore
                      type={"radio"}
                      name="group1"
                      value={e.clearingPartnerAccountPlanMappingId}
                      id={`default-radio-${i}`}
                      onChange={(e) => setinvestmentPartner(e.target.value)}
                    />

                    <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                      {!isEmpty(e.logo) ? (
                        <img
                          alt=""
                          src={e.logo}
                          style={{ width: "90px", height: "74px" }}
                          className="img-fluid"
                        />
                      ) : (
                        <GetInitials name={e.name} />
                      )}
                    </div>

                    <div className="clearing-partner-description-box">
                      <AddToolTip
                        name={e.name}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.totalPlans} Associated Plans
                      </div>
                    </div>
                  </div>
                  <div className="right-component-investment-clearing-partner">
                    <div className="inner-bank-details">
                      <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                        Clearing Partner Account Details
                      </div>
                      <AddToolTip
                        name={e.clearingPartnerId}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.description}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </SliderPanel>
      {/* <div> */}
      {/* <Field
          isRequired
          name={fields.custodianId}
          label={"Clearing Partner"}
          value={values[fields.custodianId]}
          options={
            custodianData &&
            custodianData.map((item, index) => ({
              label: item.custodianCompanyName,
              value: item.custodianPlanMapId,
            }))
          }
          popupContent={
            <SearchableList
              isRadio
              isNotTypeAhead
              label="Clearing Partner"
              name={fields.custodianId}
              onSelect={(value) => {
                setTabGrey(2);
                setFieldValue(fields.custodianId, value);
              }}
              value={values[fields.custodianId]}
              options={
                custodianData &&
                custodianData.map((item, index) => ({
                  label: item.custodianCompanyName,
                  value: item.custodianPlanMapId,
                }))
              }
              disabled={isEdit && !isSave}
              isTypeAhead
            />
          }
          disabled={isEdit && !isSave}
          component={FieldDropSide}
        />

        {values[fields.custodianId] && (
          <>
            <Field
              name={fields.custodianAccountId}
              isRequired
              label="Clearing Partner Account ID"
              value={values[fields.custodianAccountId]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.CLEAING_PARTNER_ACCOUNT_ID
              )}
              popupContent={
                <SearchableList
                  label="Select an clearing partner account id"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.CLEAING_PARTNER_ACCOUNT_ID
                  )}
                  isSelectedByDefault={true}
                  onSelect={(value) =>
                    setFieldValue(fields.custodianAccountId, value)
                  }
                  onChange={() => {
                    setTabGrey(2);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            <Field
              label={"Clearance Time (EST)"}
              size="md"
              noLabelTransform={true}
              name={fields.clearanceTime}
              value={toMultiSelectValueById(
                values[fields.clearanceTime],
                toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.CLEARANCE_TIME)
              )}
              isMultiSelect
              isRequired
              popupContent={
                <MultiSelectDropdown
                  label="Select"
                  name={fields.clearanceTime}
                  // isAllSelecetedByDefault={
                  //   toggle &&
                  //   values[fields.clearanceTime] !== undefined &&
                  //   isEmpty(values[fields.clearanceTime])
                  // }
                  setToggle={setToggle}
                  onSelect={(value) => {
                    setTabGrey(2);
                    setFieldValue(fields.clearanceTime, value);
                  }}
                  value={values[fields.clearanceTime]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.CLEARANCE_TIME
                  )}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            {clearanceTime &&
              clearanceTime.length > 1 &&
              clearanceTime.length === 2 && (
                <div className="ft-12 grey-text mb-2">
                  All Clearance time values selected. If needed, please modify.
                </div>
              )}
          </>
        )}

        <Field
          size="smd"
          name={fields.excludeInvestmentFrom}
          label={"Exclude investment from"}
          isRequired
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.EXCLUDE_INVESTMENT_FROM
          )}
          selectedValue={values[fields.excludeInvestmentFrom]}
          value={values[fields.excludeInvestmentFrom]}
          onChange={(value) => {
            setTabGrey(2);
            setFieldValue(fields.excludeInvestmentFrom, value);
          }}
          component={FieldMultiSelectButtonGroup}
          disabled={isEdit && !isSave}
        />
      </div> */}
    </LoaderWrapper>
  );
};

export default TrusteeCustodianDetails;
